import { AutoComplete, DatePicker, Form, Input, InputNumber, Select, Tooltip } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Item } from "types/models/colums-table-type";
import type { InputRef } from "antd";
import { FIELD_TYPE } from "types/enums";
import { Rule } from "antd/es/form";

const { INPUT, DATE, CURRENCY, AUTO_COMPLETE} = FIELD_TYPE;

type EditableRowProps = {
  index: number;
};
export type EditableCellProps = {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  handleSave: (record: Item) => void;
  rules: Rule[];
  disabled: boolean;
  value: any;
  thuocs: any
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  const onFinishFailed = (errorInfo: any) => {
  };

  return (
    <Form form={form} component={false} onFinishFailed={onFinishFailed}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  rules,
  disabled,
  value,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<any>(null);
  const form = useContext(EditableContext)!;
  const [inputValue, setInputValue] = useState({});

  // const [inputValue, setInputValue] = useState({});

  const onKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
  };
  const handleSetFieldValue = (dataIndex, value) => {
    form.setFieldValue(dataIndex, value);
    setInputValue({ ...inputValue, [dataIndex]: value });
    handleSave(form.getFieldsValue());
  };

  const setTongTien = () => {
    const soLuongBan = form.getFieldValue("soLuongBan");
    const donGia = form.getFieldValue("donGia");
    const vat = form.getFieldValue("vat");
    const tongTien = (soLuongBan * donGia * (100 + vat)) / 100;
    handleSetFieldValue("tongTien", tongTien);
  };
  const onSelectChange = (e) => {
    if(dataIndex == 'idThuoc') {
      // let thuoc = thuocs.find(it => it.id === e);

      // if(thuoc) {
      //   form.setFieldsValue({
      //     tenThuoc: thuoc.name,
      //     baoChe: thuoc.baoChe,
      //     hamLuong: thuoc.hamLuong,
      //     hoatChat: thuoc.hoatChat,
      //     donGiaBan: thuoc.donGiaBan
      //   });
      // }
      // save(thuoc.bhChiTra)
    }
    else {
      save()
    }
  }

  const onAutoCompleteChange = async (value, option) => {
    if(dataIndex == 'tenThuoc') {
      // let thuoc = thuocs.find(it => it.name === value);

      // if(thuoc) {
      //   form.setFieldsValue({
      //     idThuoc: thuoc.id,
      //     baoChe: thuoc.baoChe,
      //     hamLuong: thuoc.hamLuong,
      //     hoatChat: thuoc.hoatChat,
      //     donGiaBan: thuoc.donGiaBan
      //   });
      // }
      save()
    }
    else {
      save()
    }
  }
  useEffect(() => {
    inputRef.current?.focus();
  }, [editing]);
  const save = async () => {
    try {
      const values = await form.validateFields();
      let row= {
        ...record,
        ...values
      }
      handleSave(row);
    } catch (errInfo) {
      // //console.log('Save failed:', errInfo);
    }
  };

  // const handleSetFieldValue = (dataIndex, value) => {
  //   form.setFieldValue(dataIndex, value);
  //   setInputValue({ ...inputValue, [dataIndex]: value });
  //   handleSave(form.getFieldsValue(), index);
  // };
  // const save = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     toggleEdit();
  //     handleSave({ ...record, ...values }, index);
  //   } catch (errInfo) {
  //     
  //   }
  // };
  useEffect(() => {
    if( record !== undefined) {
      form.setFieldValue(dataIndex, record[dataIndex])
    }
  }, [record])
  let childNode = children;

  if (type === INPUT) {
    childNode = (
      // editing ? (
      <Form.Item
        rules={rules}
        style={{ margin: 0 }}
        name={dataIndex}
      >
        {/* <Tooltip title={record[dataIndex]}> */}
        <Input
          disabled={disabled}
          style={{ padding: 0 }}
          onPressEnter={save} onBlur={save}
          bordered={false}
        />
        {/* </Tooltip> */}
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item name={dataIndex}>
        <DatePicker bordered={false}></DatePicker>;
      </Form.Item>
    );
  }
  if (selected) {
    childNode = (
      <Form.Item style={{ margin: 0 }} name={dataIndex} initialValue={null}>
        <Select
          placeholder="Chọn"
          defaultValue={options ? options[0] : ""}
          options={options}
          onChange={onSelectChange}
          bordered={false}
        />
      </Form.Item>
    );
  }

  if (type == CURRENCY) {
    childNode = (
      <Form.Item name={dataIndex} initialValue={record[dataIndex]}>
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={(e) => {
            setInputValue({ ...inputValue, [dataIndex]: e.value });
            handleSave(form.getFieldsValue());
            if (dataIndex == "thanhTien") {
              setTongTien();
            }
          }}
          bordered={false}
          placeholder={"Nhập"}
          prefix="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (<Form.Item name={dataIndex} initialValue={null}>
      <AutoComplete
        options={options}
        placeholder="Nhập"
        size="large"
        filterOption={(inputValue, option) =>
          option!.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={onAutoCompleteChange}
        bordered={false}
      />
    </Form.Item>)
  }

  return <td {...restProps}>{childNode}</td>;
};
